import React from "react";
import { Search } from "lucide-react";

export type SubscriptionFiltersProps = {
  search: string;
  onSearch: (v: string) => void;
  filterStatut: string;
  onStatut: (v: string) => void;
  filterFrequence: string;
  onFrequence: (v: string) => void;
  filterTypeClient: string;
  onTypeClient: (v: string) => void;
  filterZone: string;
  onZone: (v: string) => void;
  zoneOptions: string[];
  impayesOnly: boolean;
  onImpayesOnly: (v: boolean) => void;
  expireBientotOnly: boolean;
  onExpireBientotOnly: (v: boolean) => void;
};

export function SubscriptionFilters(props: SubscriptionFiltersProps): React.JSX.Element {
  const {
    search,
    onSearch,
    filterStatut,
    onStatut,
    filterFrequence,
    onFrequence,
    filterTypeClient,
    onTypeClient,
    filterZone,
    onZone,
    zoneOptions,
    impayesOnly,
    onImpayesOnly,
    expireBientotOnly,
    onExpireBientotOnly,
  } = props;

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/40 p-4 shadow-lg backdrop-blur-sm md:p-5">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
        <div className="relative min-w-0 flex-1">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input
            type="search"
            placeholder="Rechercher un client…"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            className="w-full rounded-xl border border-slate-700 bg-slate-950/60 py-2.5 pl-10 pr-3 text-sm text-white outline-none ring-emerald-500/30 placeholder:text-slate-500 focus:border-emerald-500/50 focus:ring-2"
          />
        </div>

        <div className="flex flex-wrap gap-2 md:justify-end">
          <select
            value={filterStatut}
            onChange={(e) => onStatut(e.target.value)}
            className="rounded-xl border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-white outline-none focus:border-emerald-500/50 focus:ring-2 focus:ring-emerald-500/20"
          >
            <option value="">Statut contrat : tous</option>
            <option value="ACTIF">Actif</option>
            <option value="SUSPENDU">Suspendu</option>
            <option value="RESILIE">Résilié</option>
            <option value="EXPIRE">Expiré</option>
            <option value="TERMINE">Terminé</option>
          </select>

          <select
            value={filterFrequence}
            onChange={(e) => onFrequence(e.target.value)}
            className="rounded-xl border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-white outline-none focus:border-emerald-500/50 focus:ring-2 focus:ring-emerald-500/20"
          >
            <option value="">Fréquence : toutes</option>
            <option value="MENSUEL">Mensuel</option>
            <option value="HEBDOMADAIRE">Hebdomadaire</option>
            <option value="ANNUEL">Annuel</option>
            <option value="PONCTUEL">Ponctuel</option>
          </select>

          <select
            value={filterTypeClient}
            onChange={(e) => onTypeClient(e.target.value)}
            className="rounded-xl border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-white outline-none focus:border-emerald-500/50 focus:ring-2 focus:ring-emerald-500/20"
          >
            <option value="">Type client : tous</option>
            <option value="MENAGE">Ménage</option>
            <option value="ENTREPRISE">Entreprise</option>
            <option value="PROFESSIONNEL">Professionnel</option>
            <option value="CHANTIER">Chantier</option>
          </select>

          <select
            value={filterZone}
            onChange={(e) => onZone(e.target.value)}
            className="min-w-[10rem] rounded-xl border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-white outline-none focus:border-emerald-500/50 focus:ring-2 focus:ring-emerald-500/20"
          >
            <option value="">Zone : toutes</option>
            {zoneOptions.map((z) => (
              <option key={z} value={z}>
                {z}
              </option>
            ))}
          </select>

          <label className="inline-flex cursor-pointer items-center gap-2 rounded-xl border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-200">
            <input
              type="checkbox"
              checked={impayesOnly}
              onChange={(e) => onImpayesOnly(e.target.checked)}
              className="rounded border-slate-600 text-emerald-500 focus:ring-emerald-500/40"
            />
            Impayés uniquement
          </label>

          <label className="inline-flex cursor-pointer items-center gap-2 rounded-xl border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-200">
            <input
              type="checkbox"
              checked={expireBientotOnly}
              onChange={(e) => onExpireBientotOnly(e.target.checked)}
              className="rounded border-slate-600 text-emerald-500 focus:ring-emerald-500/40"
            />
            Expire bientôt
          </label>
        </div>
      </div>
    </section>
  );
}
